const map = {
  Scheduled: "status-scheduled",
  InProgress: "status-progress",
  Complete: "status-complete",
  Cancelled: "status-cancelled"
};

export default function StatusBadge({ status }) {
  const label = status === "InProgress" ? "In Progress" : status;

  return <span className={`status-badge ${map[status] || "status-scheduled"}`}>{label}</span>;
}
